module.exports = new __parcel__URL__("PRD Hover.cb81c0eb.svg").toString();